{
  "app": {
    "iframeTitle": "Fenêtre de l'app"
  },
  "associatedThreads": {
    "created": "Créée {{when}}",
    "emptyText": "Ici s'affichent les conversations avec Nolë qui ont modifié ce node.",
    "emptyTitle": "Aucune conversation IA n'a encore modifié ce node.",
    "intro": "Les conversations avec Nolë qui ont modifié ce node.",
    "loadError": "Erreur lors du chargement des conversations associées.",
    "noSummary": "Aucun résumé disponible.",
    "openInNole": "Ouvrir dans Nolë",
    "openTooltip": "Ouvrir cette conversation dans le panneau Nolë"
  },
  "audio": {
    "noAudio": "Aucun audio"
  },
  "cards": {
    "ascending": "Croissant",
    "descending": "Décroissant",
    "fieldsOnCards": "Champs sur les cartes",
    "manualOrder": "Ordre manuel",
    "new": "Nouveau",
    "sort": "Trier"
  },
  "custom": {
    "editLayout": "Modifier la mise en page",
    "hiddenFields_one": "{{count}} champ absent de la mise en page",
    "hiddenFields_other": "{{count}} champs absents de la mise en page",
    "nodeGone": "Ce node n'existe plus",
    "rowGone": "Cette ligne n'existe plus",
    "unknownTemplate": "Modèle inconnu"
  },
  "database": {
    "convertDescription": "Les lignes sont copiées dans un simple tableau, dans l'ordre de la base de données. L'historique de chaque ligne, ses vues et les lignes supprimées sont perdus. Les lignes affichées sur le canvas y restent, comme nodes indépendants. Un tableau contient au plus 1 000 lignes.",
    "convertError": "Impossible de convertir la base de données",
    "convertTitle": "Convertir en simple tableau ?",
    "convertToTable": "Convertir en simple tableau",
    "converted": "La base de données est maintenant un simple tableau.",
    "importStopped_one": "Import interrompu : {{imported}} ligne sur {{count}} importée.",
    "importStopped_other": "Import interrompu : {{imported}} lignes sur {{count}} importées.",
    "settings": "Réglages de la base de données",
    "trash": {
      "description": "Les lignes supprimées sont conservées 30 jours, puis supprimées définitivement.",
      "empty": "Aucune ligne supprimée.",
      "restoreError": "Impossible de restaurer la ligne",
      "title": "Lignes supprimées"
    },
    "updateError": "Erreur lors de la mise à jour de la base de données"
  },
  "databaseTable": {
    "detach": "Détacher",
    "detachDescription": "Elles quittent la base de données et restent sur le canvas comme nodes indépendants.",
    "detachTitle_one": "Détacher {{count}} ligne ?",
    "detachTitle_other": "Détacher {{count}} lignes ?",
    "limitHint_one": "{{count}} ligne au maximum à la fois",
    "limitHint_other": "{{count}} lignes au maximum à la fois",
    "projectOnCanvas": "Projeter sur le canvas",
    "restoreError": "Impossible de restaurer les lignes",
    "rowHidden": "Cette ligne est masquée par les filtres de cette vue, ou a été supprimée.",
    "rowsMovedToTrash_one": "{{count}} ligne déplacée dans la corbeille de cette base de données.",
    "rowsMovedToTrash_other": "{{count}} lignes déplacées dans la corbeille de cette base de données."
  },
  "databaseView": {
    "addError": "Impossible d'ajouter la vue",
    "added": "Vue « {{view}} » ajoutée à côté de la base de données.",
    "databaseGone": "Sa base de données est dans la corbeille ou sur un autre canvas",
    "newView": "Nouvelle vue",
    "openDatabase": "Ouvrir {{title}}",
    "renameError": "Impossible de renommer la vue",
    "types": {
      "gallery": "Galerie",
      "kanban": "Kanban",
      "table": "Tableau",
      "timeline": "Chronologie"
    },
    "untitled": "Vue sans titre",
    "updateError": "Impossible de mettre à jour la vue"
  },
  "dialogs": {
    "threads": "Conversations qui ont modifié ce node",
    "versionHistory": "Historique des versions"
  },
  "errorBoundary": {
    "message": "Recharger la page règle généralement le problème — votre travail est enregistré sur le serveur.",
    "title": "Impossible d'ouvrir cette fenêtre"
  },
  "frame": {
    "empty": "Cette frame est vide",
    "emptyEditable": "Cette frame est vide — faites un clic droit pour ajouter un node",
    "exitFullscreen": "Quitter le plein écran",
    "expand": "Agrandir",
    "expandFullscreen": "Passer en plein écran",
    "maxMinimized_one": "Vous ne pouvez pas réduire plus de {{count}} fenêtre",
    "maxMinimized_other": "Vous ne pouvez pas réduire plus de {{count}} fenêtres",
    "minimize": "Réduire",
    "moreOptions": "Plus d'options",
    "navigateToNode": "Aller au node",
    "pin": "Épingler au panneau de droite",
    "refresh": "Actualiser la fenêtre",
    "unpin": "Détacher : en faire une fenêtre flottante"
  },
  "image": {
    "addImage": "Ajouter une image",
    "alt": "Image sélectionnée"
  },
  "kanban": {
    "addStatus": "Ajouter un champ Statut",
    "checked": "Coché",
    "firstOf": "{{shown}} premiers sur {{count}}",
    "groupBy": "Grouper par {{field}}",
    "noValue": "Sans {{field}}",
    "pickerHint": "Un kanban regroupe les lignes selon un champ de sélection, de statut ou une case à cocher.",
    "showMore": "Afficher plus ({{count}})",
    "statusFieldName": "Statut",
    "unchecked": "Non coché"
  },
  "link": {
    "noLink": "Aucun lien",
    "openInNewTab": "Ouvrir dans un nouvel onglet"
  },
  "links": {
    "backlinks": {
      "empty": "Aucun node ne mentionne celui-ci pour l'instant.",
      "hint": "Les nodes qui mentionnent celui-ci, par @mention ou référence dans un tableau.",
      "title": "Rétroliens"
    },
    "connections": {
      "empty": "Aucune connexion pour l'instant.",
      "hint": "Les connexions de ce node vers d'autres nodes sur le canvas.",
      "incoming": "Source — ce bloc pointe vers le bloc actuel",
      "outgoing": "Cible — le bloc actuel pointe vers ce bloc",
      "title": "Connexions"
    },
    "database": {
      "rowHint": "La base de données à laquelle appartient cette ligne.",
      "title": "Base de données",
      "viewHint": "La base de données qu'affiche cette vue.",
      "views": "Vues",
      "viewsHint": "Les vues de cette base de données sur le canvas."
    },
    "node": "Node",
    "threads": {
      "empty": "Aucune conversation avec Nolë n'a encore modifié ce node.",
      "hint": "Les conversations avec Nolë qui ont créé ou modifié ce node.",
      "notOwner": "Cette conversation appartient à un autre utilisateur",
      "openInPanel": "Ouvrir dans le panneau Nolë",
      "title": "Conversations",
      "untitled": "Conversation sans titre"
    }
  },
  "loadingState": {
    "creating": "Création",
    "loading": "Chargement",
    "preparingDocument": "Préparation du document"
  },
  "outline": {
    "empty": "Ajoutez des titres pour générer le plan.",
    "pdfEmpty": "Aucun plan disponible.",
    "pdfNotIndexed": "Le texte de ce PDF n'est pas encore indexé : la recherche n'est pas possible.",
    "title": "Plan"
  },
  "pdf": {
    "nextPage": "Page suivante",
    "pageOf": "Page {{page}} sur {{total}}",
    "previousPage": "Page précédente",
    "resetZoom": "Réinitialiser le zoom",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière"
  },
  "file": {
    "noFile": "Aucun fichier",
    "noPreview": "Pas d'aperçu pour ce type de fichier : téléchargez-le pour l'ouvrir.",
    "openInNewTab": "Ouvrir dans un nouvel onglet",
    "previewFailed": "Impossible de prévisualiser ce fichier : téléchargez-le pour l'ouvrir.",
    "emptySheet": "Cette feuille est vide.",
    "rowsCapped": "{{shown}} premières lignes sur {{total}} : téléchargez le fichier pour tout voir.",
    "pagesNotIndexed": "L'aperçu apparaît une fois le fichier indexé, une minute environ après l'import.",
    "slideNumber": "Diapositive {{n}}",
    "kinds": {
      "pdf": "Document PDF",
      "image": "Image",
      "audio": "Audio",
      "video": "Vidéo",
      "word": "Document Word",
      "spreadsheet": "Tableur",
      "presentation": "Présentation",
      "text": "Fichier texte",
      "archive": "Archive",
      "other": "Fichier"
    }
  },
  "row": {
    "delete": "Supprimer la ligne",
    "detachError": "Impossible de détacher la ligne",
    "detachFrom": "Détacher de {{database}}",
    "detachManyError": "Impossible de détacher les lignes",
    "detached": "Détachée de la base de données. Elle reste sur le canvas.",
    "inTrash": "Cette ligne est dans la corbeille de sa base de données.",
    "manyDetached_one": "{{count}} ligne détachée de la base de données. Elle reste sur le canvas.",
    "manyDetached_other": "{{count}} lignes détachées de la base de données. Elles restent sur le canvas.",
    "manyShownOnCanvas_one": "{{count}} ligne affichée sur le canvas. Elle reste dans cette base de données.",
    "manyShownOnCanvas_other": "{{count}} lignes affichées sur le canvas. Elles restent dans cette base de données.",
    "movedToTrash": "Ligne déplacée dans la corbeille de cette base de données.",
    "projectOnCanvas": "Projeter en node sur le canvas",
    "showError": "Impossible d'afficher la ligne sur le canvas",
    "showIn": "Afficher dans {{database}}",
    "showManyError": "Impossible d'afficher les lignes sur le canvas",
    "shownOnCanvas": "Affichée sur le canvas. Elle reste dans cette base de données.",
    "theDatabase": "la base de données"
  },
  "search": {
    "noResults": "Aucun résultat",
    "nothingMatches": "Aucun résultat pour « {{query}} ».",
    "resultsAtLeast_one": "{{count}}+ résultat",
    "resultsAtLeast_other": "{{count}}+ résultats",
    "results_one": "{{count}} résultat",
    "results_other": "{{count}} résultats"
  },
  "sectionLabel": {
    "about": "À propos : {{name}}",
    "aboutThis": "À propos de cette section"
  },
  "sidePanel": {
    "clearSearch": "Effacer la recherche",
    "plan": {
      "nothingToShow": "Rien à afficher pour ce type de node."
    },
    "searchPlaceholder": "Rechercher dans ce node",
    "tabs": {
      "links": "Liens",
      "plan": "Plan",
      "versions": "Versions"
    },
    "title": "Panneau",
    "toggle": "Afficher ou masquer le panneau latéral"
  },
  "table": {
    "convert": "Convertir",
    "convertDescription": "Chaque ligne devient une fiche avec son propre historique, que l'on peut ouvrir, lier et traiter une par une. Les colonnes deviennent les champs de la base de données.",
    "convertError": "Impossible de convertir le tableau",
    "convertTitle": "Convertir en base de données ?",
    "convertToDatabase": "Convertir en base de données",
    "converted": "Le tableau est maintenant une base de données.",
    "defaultColumnName": "Colonne {{n}}",
    "emptyCell": "{{column}} (vide)",
    "emptyRow": "Ligne vide",
    "exportCsv": "Exporter en CSV",
    "exportFileName": "tableau",
    "importCsv": "Importer un fichier CSV",
    "rowHidden": "Cette ligne est masquée par la recherche ou les filtres du tableau.",
    "rowsDeleted_one": "{{count}} ligne supprimée.",
    "rowsDeleted_other": "{{count}} lignes supprimées.",
    "settings": "Réglages du tableau",
    "updateError": "Erreur lors de la mise à jour du tableau",
    "visibleOfTotal_one": "{{visible}} sur {{count}} ligne",
    "visibleOfTotal_other": "{{visible}} sur {{count}} lignes"
  },
  "tableMeta": {
    "columns_one": "{{count}} colonne",
    "columns_other": "{{count}} colonnes",
    "rows_one": "{{count}} ligne",
    "rows_other": "{{count}} lignes"
  },
  "timeline": {
    "earlier": "Plus tôt",
    "emptyPeriod": "Aucune ligne datée sur cette période.",
    "inRangeAtLeast_one": "{{count}}+ dans la période",
    "inRangeAtLeast_other": "{{count}}+ dans la période",
    "inRange_one": "{{count}} dans la période",
    "inRange_other": "{{count}} dans la période",
    "later": "Plus tard",
    "noDateField": "Une chronologie place les lignes selon un champ date. Ajoutez-en un, puis choisissez-le dans les options de cette vue.",
    "today": "Aujourd'hui",
    "undated": "Sans {{field}} ({{n}})",
    "undatedDrag": "Sans {{field}} ({{n}}) — faites-en glisser une sur la chronologie",
    "zoom": {
      "month": "Mois",
      "quarter": "Trimestre",
      "week": "Semaine"
    }
  },
  "transcript": {
    "askNole": {
      "label": "Un nom ou un mot mal compris ? Demandez à Nolë de le corriger dans la transcription.",
      "prompt": "Dans cette transcription, remplacez "
    },
    "empty": {
      "audio": {
        "callToAction": "Transcrivez cet audio pour le lire ici, aller directement à n'importe quel passage, et retrouver ce qui a été dit depuis la recherche et depuis Nolë.",
        "unavailable": "La transcription n'est pas disponible pour cet audio."
      },
      "failed": "La transcription a échoué.",
      "keepsGoing": "Vous pouvez fermer cette fenêtre, la transcription continue.",
      "tooLarge": "Ce fichier est trop volumineux pour être transcrit.",
      "tooLargeMax": "Ce fichier est trop volumineux pour être transcrit ({{max}} Mo max).",
      "transcribe": "Transcrire",
      "transcribing": "Transcription en cours…",
      "transcribingParts": "Transcription en cours… {{done}}/{{total}} parties",
      "video": {
        "callToAction": "Transcrivez cette vidéo pour la lire ici, aller directement à n'importe quel passage, et retrouver ce qui a été dit depuis la recherche et depuis Nolë.",
        "unavailable": "La transcription n'est pas disponible pour cette vidéo."
      }
    },
    "export": {
      "copied": "Transcription copiée dans le presse-papiers",
      "copyError": "Impossible de copier la transcription",
      "copyMarkdown": "Copier en Markdown",
      "copyText": "Copier le texte",
      "downloadTxt": "Télécharger (.txt)",
      "includeTimestamps": "Inclure les horodatages",
      "subtitles": "Sous-titres ({{ext}})",
      "text": "Texte (.txt)",
      "tooltip": "Copier ou télécharger la transcription",
      "trigger": "Exporter"
    },
    "item": "Élément {{number}}",
    "outline": {
      "chapters": "Chapitres",
      "chaptersHint": "L'enregistrement découpé par sujet. Cliquez sur un chapitre pour l'écouter.",
      "noChapters": "Pas encore de chapitres — ils apparaissent peu après une transcription.",
      "noTranscriptAudio": "Pas encore de transcription. Transcrivez cet audio pour obtenir un plan.",
      "overview": "Résumé",
      "overviewHint": "Un résumé de tout l'enregistrement, généré à partir de sa transcription."
    },
    "panel": {
      "chaptersHint": "L'enregistrement découpé par sujet. Ouvrez un chapitre pour le lire ; cliquez sur une ligne pour lancer la lecture à partir de là.",
      "generatedHint": "Texte généré à partir du contenu de ce node, utilisé pour la recherche.",
      "matches_one": "Transcription · {{count}} résultat",
      "matches_other": "Transcription · {{count}} résultats",
      "noneYet": "Aucune transcription disponible pour l'instant.",
      "playFrom": "Lire à partir de {{time}}",
      "showLess": "Afficher moins",
      "showMore": "Afficher plus",
      "transcript": "Transcription",
      "transcriptHint": "Cliquez sur une ligne pour lancer la lecture à partir de là. Les chapitres apparaissent peu après une transcription."
    },
    "retranscribe": {
      "label": "Retranscrire",
      "running": "Nouvelle transcription en cours — celle-ci sera remplacée une fois terminée.",
      "tooltip": "Transcrire à nouveau ce fichier — la transcription actuelle, et les corrections qui y ont été faites, seront remplacées"
    }
  },
  "versions": {
    "author": {
      "agentFor": "Nolë pour {{name}}",
      "someone": "Quelqu'un",
      "system": "Système",
      "unknown": "Auteur inconnu",
      "you": "Vous"
    },
    "banner": {
      "changes": "Modifications",
      "highlightChanges": "Surligner les modifications",
      "restore": "Restaurer",
      "restoreAppText": "Le code de cette version va être restauré. Les données enregistrées par votre app ne sont pas touchées. Le code actuel est conservé comme version : vous pourrez y revenir à tout moment.",
      "restoreText": "Le contenu actuel va être remplacé par cette version. Il est conservé comme version : vous pourrez y revenir à tout moment.",
      "restoreTitle": "Restaurer cette version",
      "restoring": "Restauration…",
      "version": "Version"
    },
    "day": {
      "dateTime": "{{day}} à {{time}}",
      "formatOtherYear": "d MMMM yyyy",
      "formatThisYear": "EEEE d MMMM",
      "today": "Aujourd'hui",
      "yesterday": "Hier"
    },
    "diff": {
      "added": "Ajouté",
      "changed": "Modifié",
      "fields": "Champs : {{fields}}",
      "none": "Aucune modification",
      "oldest": "Plus ancienne version conservée : rien d'antérieur à comparer",
      "removed": "Supprimé",
      "since": "Modifications depuis {{title}}",
      "tableMetaChanged": "Les colonnes ou les réglages de vue ont changé dans cette version.",
      "unavailable": "Modifications indisponibles."
    },
    "history": {
      "loadError": "Erreur lors du chargement de l'historique des versions.",
      "noEarlier": "Pas encore de version antérieure : elles apparaissent au fil des modifications de ce bloc.",
      "notVersioned": "Ce bloc n'a pas d'historique des versions.",
      "showOlder": "Afficher les versions plus anciennes"
    },
    "kind": {
      "baseline": "Version antérieure",
      "created": "Création",
      "restored": "Restaurée",
      "restoredFrom": "Restaurée depuis {{title}}"
    },
    "list": {
      "current": "Version actuelle",
      "nameCurrent": "Nommer la version actuelle",
      "nameError": "Erreur lors du nommage de la version",
      "namePlaceholder": "Nom de la version (vide pour le retirer)",
      "nameThis": "Nommer cette version",
      "rename": "Renommer la version",
      "statsTooltip": "Blocs, lignes ou champs ajoutés, supprimés et modifiés",
      "upToDate": "À jour"
    },
    "preview": {
      "empty": "Vide.",
      "emptyDocument": "Document vide.",
      "noCode": "Aucun code dans cette version.",
      "noLongerAvailable": "Cette version n'est plus disponible.",
      "restoreError": "Erreur lors de la restauration de la version",
      "restored": "Version restaurée.",
      "templateUnresolved": "Aperçu indisponible (modèle introuvable).",
      "unavailable": "Aperçu indisponible."
    },
    "viewer": {
      "pick": "Choisissez une version pour voir ce qu'elle contenait et ce qui a changé."
    }
  },
  "video": {
    "noVideo": "Aucune vidéo",
    "noVideoYet": "Pas encore de vidéo."
  },
  "viewHeader": {
    "partial": "Seules les premières lignes de la base de données ont été lues : il peut y en avoir davantage.",
    "rowHeight": "Hauteur des lignes",
    "searchPlaceholder": "Rechercher…"
  },
  "viewSettings": {
    "addEndDates": "Ajouter des dates de fin à {{field}}",
    "cover": "Couverture",
    "endDate": "Date de fin",
    "endOf": "Fin de {{field}}",
    "groupBy": "Grouper par",
    "layout": "Disposition",
    "startDate": "Date de début",
    "title": "Réglages de la vue"
  }
}
